import { ModelBase } from "../abstract/model-base.model";
import { AnalyticalAxis } from "./analytical-axis.model";

export class AnalyticalSection extends ModelBase {

    static override CLASS_NAME: string = 'AnalyticalSection';

    private _axis!: AnalyticalAxis;
    private _closed!: boolean;
    private _code!: string;
    private _label!: string;

    public override toString(): string {
        return this._label;
    }

    public get axis(): AnalyticalAxis {
        return this._axis;
    }

    public set axis(value: any) {
        this._setValue('_axis', value, 'AnalyticalAxis');
    }

    public get closed(): boolean {
        return this._closed;
    }

    public set closed(value: any) {
        this._setValue('_closed', value, 'boolean');
    }

    public get code(): string {
        return this._code;
    }

    public set code(value: any) {
        this._setValue('_code', value, 'string');
    }

    public get label(): string {
        return this._label;
    }

    public set label(value: any) {
        this._setValue('_label', value, 'string');
    }
}
